module.exports = __webpack_public_path__ + "static/pic03-4a0c3d00500db4c2e488def23bba7e3a.jpg";